import type { FeatureFlagOverrides } from '../types';

export const featureFlagOverrides: FeatureFlagOverrides = {};
